"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _shoutoutThemesEnterprise = require("@shoutout-labs/shoutout-themes-enterprise");

var _Preview = _interopRequireDefault(require("./../preview/Preview"));

var _Modifiers = require("./../utils/Modifiers");

var _EditorContext = require("../../EditorContext");

require("./SettingsTools.css");

var _excluded = ["settingsComponents", "previewComponent"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SettingsTools = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SettingsTools, _React$Component);

  function SettingsTools() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.state = {
      show: false
    };
    _this._clear = _this._clear.bind(_assertThisInitialized(_this));
    _this._onClosePreview = _this._onClosePreview.bind(_assertThisInitialized(_this));
    _this._showPreview = _this._showPreview.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = SettingsTools.prototype;

  _proto._clear = function _clear(e) {
    e.stopPropagation();
    this.context.onChangeEditorState((0, _Modifiers.resetWithDefaultTemplate)(this.context.metadata));
  };

  _proto._onClosePreview = function _onClosePreview(e) {
    e.stopPropagation();
    this.setState({
      show: false
    });
  };

  _proto._showPreview = function _showPreview(e) {
    e.stopPropagation();
    this.setState({
      show: true
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        settingsComponents = _this$props.settingsComponents,
        previewComponent = _this$props.previewComponent,
        rest = _objectWithoutPropertiesLoose(_this$props, _excluded);

    var _this$context = this.context,
        metadata = _this$context.metadata,
        editorState = _this$context.editorState,
        onChangeEditorState = _this$context.onChangeEditorState;
    var PreviewComponent = previewComponent || _Preview["default"];
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "btn-settings-wrapper d-flex flex-row justify-content-end align-items-center"
    }, settingsComponents.map(function (component, index) {
      return component(_extends({}, rest, {
        key: "cst-" + index,
        editorState: editorState,
        metadata: metadata,
        onChangeEditorState: onChangeEditorState
      }));
    }), /*#__PURE__*/_react["default"].createElement(_shoutoutThemesEnterprise.Button, {
      variant: "transparent",
      className: "mx-2 shadow card",
      onClick: this._showPreview,
      size: "sm"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "mx-auto text-primary"
    }, "Preview")), /*#__PURE__*/_react["default"].createElement(_shoutoutThemesEnterprise.Button, {
      ariant: "transparent",
      className: "px-2 shadow card",
      onClick: this._clear,
      size: "sm"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "mx-auto text-danger"
    }, "Clear")), /*#__PURE__*/_react["default"].createElement(PreviewComponent, {
      show: this.state.show,
      onClose: this._onClosePreview,
      editorState: editorState
    }));
  };

  return SettingsTools;
}(_react["default"].Component);

_defineProperty(SettingsTools, "contextType", _EditorContext.EditorContext);

var _default = SettingsTools;
exports["default"] = _default;
module.exports = exports.default;